import { render, staticRenderFns } from "./ConfigMeta.vue?vue&type=template&id=180cd96c&"
import script from "./ConfigMeta.vue?vue&type=script&lang=js&"
export * from "./ConfigMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports